<!-- 检查表 -->
<template>
  <div class="nx-list-page">
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      :beforeOpen="beforeOpen"
      @on-load="onLoad"
      @row-del="rowDel"
    >
      <template slot-scope="{ row }" slot="timeAndUser">
        <div>{{ row.updateName || "—" }}</div>
      </template>
      <template slot-scope="{ row }" slot="status">
        <matrix-tag
          v-if="isStatusEnabled(row)"
          color="#166534"
          text="启用"
        />
        <matrix-tag
          v-else
          color="#64748b"
          text="停用"
        />
      </template>
      <template #menu="{ size, row }">
        <el-button
          v-if="isStatusEnabled(row)"
          type="text"
          :size="size"
          @click="onChangeStatus(row.id, 'disable')"
        >
          停用
        </el-button>
        <el-button
          v-else
          type="text"
          :size="size"
          @click="onChangeStatus(row.id, 'enable')"
        >
          启用
        </el-button>
      </template>
    </avue-crud>
    <dialog-reset slotShow height="80vh" top="3vh" width="60%" :title="formTitle" :visible.sync="formVisible">
      <form-component ref="formComponent" :transmit-data="transmitData" @handleClose="handleClose" />
    </dialog-reset>
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { getList, changeStatus, remove } from "./api";
import { transitionTitle } from "@/basic-common/util/common";
import matrixTag from "@/components/matrix/matrix-tag";
import FormComponent from "./components/form-component.vue";

export default {
  name: "DispatchCheckListIndex",
  components: { matrixTag, FormComponent },
  mixins: [crudMixins],
  data () {
    return {
      transmitData: {},
      formVisible: false,
      formTitle: "",
      apiConfig: { getList, remove },
      option: {
        ...this.$store.state.publicOption,
        menuWidth: 140,
        column: [
          {
            label: "检查表编号",
            prop: "checkListCode",
            search: true,
            span: 12,
            overHidden: true,
            minWidth: 140,
          },
          {
            label: "检查表名称",
            prop: "checkListName",
            search: true,
            span: 12,
            overHidden: true,
            minWidth: 140,
          },
          {
            label: "检查类型",
            prop: "checkType",
            search: true,
            dicUrl: "/api/produce/safey-type/select/querySafeyType?safeyType=1",
            dataType: "string",
            type: "select",
            props: {
              label: "typeName",
              value: "typeCode",
            },
          },
          {
            label: "检查项数量",
            prop: "itemCount",
            overHidden: true,
            width: 110,
          },
          {
            label: "状态",
            prop: "status",
            type: "select",
            slot: true,
            align: "center",
            className: "cell-check-status",
            overHidden: false,
            width: 90,
            search: true,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=enable_flag",
            dataType: "string",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
          },
          {
            label: "最新更新人",
            prop: "timeAndUser",
            slot: true,
            className: "cell-check-update-user",
            overHidden: false,
            minWidth: 100,
          },
          {
            label: "责任部门",
            prop: "applicableScope",
            overHidden: true,
            search: true,
            type: "select",
            dicUrl: "/api/produce/blade-dept/select/deptSelect",
            props: {
              label: "deptName",
              value: "id",
            },
            hide: false,
            rules: [
              { max: 500, message: "责任部门(适用区域)不能超过500个字符", trigger: "blur" },
            ],
          },
          {
            label: "备注",
            prop: "remark",
            type: "textarea",
            span: 24,
            minRows: 3,
            hide: true,
            search: false,
            rules: [
              { max: 500, message: "备注不能超过500个字符", trigger: "blur" },
            ],
          },
          {
            label: "版本",
            prop: "version",
            hide: true,
            search: false,
          },
        ],
      },
    };
  },
  methods: {
    /** 启用：兼容 1 / "1" */
    isStatusEnabled (row) {
      const s = row.status;
      return s === 1 || s === "1";
    },
    beforeOpen (done, type) {
      this.transmitData = {
        type,
        id: this.form.id || null,
      };
      this.formTitle = transitionTitle(type);
      this.formVisible = true;
    },
    handleClose (type) {
      this.formVisible = false;
      if (type) {
        this.onLoad(this.page, this.query);
      }
    },
    onChangeStatus (id, type) {
      changeStatus(id, type)
        .then(() => {
          this.$message.success("操作成功");
          this.onLoad(this.page, this.query);
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep td.cell-check-update-user .cell,
::v-deep td.cell-check-status .cell {
  overflow: visible;
}
</style>
